<template>
    <div class="container">
        <div class="page-title pull-left">
            <h2 class="entry-title">
                <div v-if="getPathName('services')">{{ services[getCurrentLocale] }}<span style="font-size: 1.0rem; font-weight:600;">{{ getSharedAgencyLoginResultsAgencyObject !== null ? ' - ' + JSON.parse(getSharedAgencyLoginResultsAgencyObject).companyName : '' }}</span></div>
                <div v-if="getPathName('booking')">{{ booking[getCurrentLocale] }}<span style="font-size: 1.0rem; font-weight:600;">{{ getSharedAgencyLoginResultsAgencyObject !== null ? ' - ' + JSON.parse(getSharedAgencyLoginResultsAgencyObject).companyName : '' }}</span></div>
                <div v-if="getPathName('flighttransfer')">{{ flighttransfer[getCurrentLocale] }}<span style="font-size: 1.0rem; font-weight:600;">{{ getSharedAgencyLoginResultsAgencyObject !== null ? ' - ' + JSON.parse(getSharedAgencyLoginResultsAgencyObject).companyName : '' }}</span></div>
                <div v-if="getPathName('addinfant')">{{ addinfant[getCurrentLocale] }}<span style="font-size: 1.0rem; font-weight:600;">{{ getSharedAgencyLoginResultsAgencyObject !== null ? ' - ' + JSON.parse(getSharedAgencyLoginResultsAgencyObject).companyName : '' }}</span></div>
                <div v-if="getPathName('rebooking')">{{ rebooking[getCurrentLocale] }}<span style="font-size: 1.0rem; font-weight:600;">{{ getSharedAgencyLoginResultsAgencyObject !== null ? ' - ' + JSON.parse(getSharedAgencyLoginResultsAgencyObject).companyName : '' }}</span></div>
            </h2>
        </div>

        <div class="pull-right" style="margin-left: 20px; margin-top:14px;">
            <a id="back-to-bottom" href="#" class="animated" data-animation-type="bounce">
                <i class="soap-icon-longarrow-bottom circle" style="color: white; font-size: 15px;"></i>
            </a>
        </div>

        <ul class="breadcrumbs pull-right">
            <li><a href="#">HOME</a></li>
            <li class="active">
                <span v-if="getPathName('services')">{{ services[getCurrentLocale] }}</span>
                <span v-if="getPathName('booking')">{{ booking[getCurrentLocale] }}</span>
                <span v-if="getPathName('flighttransfer')">{{ flighttransfer[getCurrentLocale] }}</span>
                <span v-if="getPathName('addinfant')">{{ addinfant[getCurrentLocale] }}</span>
                <span v-if="getPathName('rebooking')">{{ rebooking[getCurrentLocale] }}</span>
            </li>
        </ul>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                direct: {
                    en: 'DIRECT',
                    de: 'DIREKT',
                },
                booking: {
                    en: 'Flight Booking',
                    de: 'Flugbuchung',
                },
                services: {
                    en: 'Seats and Services',
                    de: 'Sitzplätze und Services',
                },
                rebooking: {
                    en: 'Edit Booking',
                    de: 'Buchung bearbeiten',
                },
                flighttransfer: {
                    en: 'Flight Transfer',
                    de: 'Flugumbuchung',
                },
                addinfant: {
                    en: 'Add Infant',
                    de: 'Kleinkind zufügen',
                },
                mybookings: {
                    en: 'My Bookings',
                    de: 'Meine Buchungen',
                },
                flightplan: {
                    en: 'Flight Plan',
                    de: 'Flugplan',
                },
                pressreleases: {
                    en: 'Press releases',
                    de: 'Pressemitteilungen',
                },
                career: {
                    en: 'Career',
                    de: 'Karriere',
                },
                agency: {
                    en: 'Agency',
                    de: 'Agentur',
                },
                infos_luggage: {
                    en: 'Lugagge',
                    de: 'Gepäck',
                },
                infos_dangerous_goods: {
                    en: 'Dangerous Goods',
                    de: 'Gefährliche Güter',
                },
                infos_prohibited_items: {
                    en: 'Prohibited Items',
                    de: 'Verbotene Gegenstände',
                },
                infos_additional_services: {
                    en: 'Additional Services',
                    de: 'Zusatzleistungen',
                },
                infos_serviceonboard: {
                    en: 'Service on board',
                    de: 'Service an Board',
                },
                infos_seat_reservation: {
                    en: 'Seat Reservation',
                    de: 'Sitzplatzreservierung',
                },
                infos_fare_conditions: {
                    en: 'Fare Conditions',
                    de: 'Tarifbestimmungen',
                },
                infos_complaints: {
                    en: 'Complaints',
                    de: 'Reklamationen',
                },
                infos_group_booking: {
                    en: 'Group Booking',
                    de: 'Gruppenbuchung',
                },
                infos_covid19: {
                    en: 'Covid19',
                    de: 'Covid19',
                },
                infos_infoalert: {
                    en: 'Info Alert',
                    de: 'Informationsmeldung',
                },
                // >>> ------------------------------------
                currentUrl: ''
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getSharedAgencyLoginResultsAgencyObject',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Utilities - Common'
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * getPathName()
            *
            * Desc:
            * Note:
            *
            * @param {string} pathname ()
            * @param
            * @return
            */
            getPathName: function (pathname) {

                var me = this,
                    currentUrl = window.location.pathname,
                    currentUrl = currentUrl.slice(1,-1);


                // me.$toc('>>> shared/header/LanguageList.vue >>> getPathName');
                if (pathname === currentUrl) {
                    return true;
                } else {
                    return false;
                }

            }, // eof getPathName()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style >
    .page-title-container {
        height: 56px;
        background: #4e8a62;
    }

    .page-title-container .breadcrumbs li.active {
        color: rgb(233, 173, 190);
    }
</style>